import { api } from '@/_api'

export const category = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    add(state, category) {
      state.list.unshift(Object.assign({}, category))
    },
    edit(state, category) {
      let idx = state.list.findIndex((el, i, arr) => el.id == category.id)
      state.list.splice(idx, 1, Object.assign({}, category))
    },
    remove(state, id) {
      let idx = state.list.findIndex((el, i, arr) => el.id == id)
      state.list.splice(idx, 1)
    }
  },
  actions: {
    add({ commit }, { item, callback }) {
      api.category.create(item).then((d) => {
        if (callback(d))
          commit('add', d)
      })
    },
    edit({ commit }, { item, callback }) {
      api.category.update(item).then((d) => {
        if (callback(d))
          commit('edit', d);
      })
    },
    remove({ commit }, { id, callback, error }) {
      api.category.remove(id).then(() => {
        commit('remove', id);
        callback();
      }).catch(e => error(e))
    }
  },
  getters: {
    categories: state => {
      if (state.list.length == 0)
        api.category.list()
          .then(data => state.list = data);
      return state.list;
    }
  }
}